import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';
import { NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterModule, LoadSpinnerComponent, NgbTooltipModule],
})
export class AppComponent {
  constructor(tooltipConfig: NgbTooltipConfig) {
    tooltipConfig.container = 'body';
    tooltipConfig.placement = 'top';
  }
}
